<template>
  <div>
    <e-dialog dialogTitle="发票信息"
              :centerDialogVisible="dialogVisible"
              @updateVisible="closeDialog"
              @resetPopupData="closeDialog"
              :popupWidth="'500px'"
              :showBtn="false">
      <div style="margin-left: 40px">
        <div class="margin-b10">发票类型: {{ orderInvoiceVO.invoiceType == "101" ? "增值税普通发票": "增值税专用发票"}}</div>
        <div class="margin-b10">发票抬头: {{ orderInvoiceVO.customer}}</div>
        <div class="margin-b10">纳税人识别号: {{orderInvoiceVO.identificationNumber }}</div>
        <div v-if="orderInvoiceVO.invoiceType == '102'">
          <div class="margin-b10">注册地址: {{orderInvoiceVO.registerAddress }}</div>
          <div class="margin-b10">注册电话: {{ orderInvoiceVO.telephone}}</div>
          <div class="margin-b10">开户银行: {{ orderInvoiceVO.bank}}</div>
          <div class="margin-b10">银行账号: {{orderInvoiceVO.bankAccount }}</div>
        </div>
        <div class="margin-b10">收票地址: {{ orderInvoiceVO.address }}</div>
         <div class="margin-b10">收票人信息: {{orderInvoiceVO.receiveName}} {{orderInvoiceVO.receivePhone}}</div>
       </div>
    </e-dialog>
  </div>
</template>

<script>
  import eDialog from "@/components/common/epecDialog.vue"

  export default {
    name: "invoiceDetailDialog",
    components: {eDialog},
    props: {
      dialogVisible: Boolean,
      orderInvoiceVO: Object,
    },
    data() {
      return {}
    },
    methods: {
      closeDialog() {
        this.$emit('closeDialog');
      },
    },
  }
</script>

<style scoped lang="scss">

</style>
